export const getIconColor = (
  buttonName: string,
  activeButton: string | null,
): string => {
  return activeButton === buttonName ? "#7C7C78" : "currentColor";
};
